import { FormikProps } from "formik/dist/types"
import clsx from "clsx"
import { ReactNode } from "react"
import { ObjectSchema } from "yup"
import { useMask } from "@react-input/mask"
import useFormik from "./useFormik"

const MyInputMaskFormField = ({
     label,
     name,
     formikProps,
     placeholder,
     mask,
     maskRegex,
     autoComplete = "off",
     inputMode = "text",
     classNameLayout,
     classNameLabel,
     classNameField,
     autoFocus,
     validationSchema,
     footerRightSide,
     inputRightSideIcon,
}: IPropsModel) => {
     const { isFieldValid, isFieldOnError, getFieldErrorMessage, isFieldRequired } = useFormik()

     const inputRef = useMask({
          mask: mask,
          replacement: { _: maskRegex },
     })

     return (
          <div className={clsx("row", classNameLayout)}>
               <div className={clsx("col-12 d-flex align-items-center", classNameLabel)}>
                    {label && (
                         <label
                              className={clsx("fs-6 fw-bolder text-gray-900", {
                                   required: validationSchema && isFieldRequired(validationSchema, name),
                              })}
                         >
                              {label}
                         </label>
                    )}
               </div>
               <div
                    className={clsx("col-12", classNameField, {
                         "mt-1": label,
                    })}
               >
                    <div className={"input-group"}>
                         <input
                              {...formikProps?.getFieldProps(name)}
                              type={"text"}
                              inputMode={inputMode}
                              placeholder={placeholder}
                              autoComplete={autoComplete}
                              className={clsx("form-control bg-transparent", { "border-danger": formikProps && isFieldOnError(formikProps, name) })}
                              autoFocus={autoFocus}
                              value={
                                   formikProps?.getFieldProps(name).value === undefined || formikProps.getFieldProps(name).value === null
                                        ? ""
                                        : formikProps.getFieldProps(name).value
                              }
                              ref={inputRef}
                         />
                         {inputRightSideIcon && (
                              <span
                                   className={clsx(
                                        "input-group-text",
                                        { "border-danger": formikProps && isFieldOnError(formikProps, name) },
                                        {
                                             "border-success": formikProps && isFieldValid(formikProps, name),
                                        }
                                   )}
                              >
                                   <i className={`fas fa-${inputRightSideIcon}`} />
                              </span>
                         )}
                    </div>
                    {(formikProps || footerRightSide) && (
                         <div className="row">
                              <div className="col text-start">
                                   {formikProps && isFieldOnError(formikProps, name) && <div className="text-danger">{getFieldErrorMessage(formikProps, name)}</div>}
                              </div>
                              {footerRightSide && <div className="col text-end">{footerRightSide}</div>}
                         </div>
                    )}
               </div>
          </div>
     )
}

interface IPropsModel {
     label?: ReactNode
     name: string
     formikProps: FormikProps<any> | null
     placeholder: string
     mask: string
     maskRegex: RegExp
     inputMode?: "text" | "numeric" | "tel" | "email"
     autoComplete?: "on" | "off"
     classNameLayout?: string
     classNameLabel?: string
     classNameField?: string
     autoFocus?: boolean
     validationSchema?: ObjectSchema<any>
     footerRightSide?: ReactNode
     inputRightSideIcon?: string
}

export default MyInputMaskFormField
